import { Badge } from "@odingard/design-system";

// Demo-mode banner: rendered whenever the Worker answered Vendor AI from the
// deterministic fixture layer, so fixture vendors are never mistaken for the
// governed register.
export function VendorDemoBanner({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <div className="ods-failclosed" role="status" style={{ borderColor: "var(--ods-color-warning)" }}>
      <strong>Demo data.</strong> Vendor AI is running against the deterministic fixture layer, not a live
      backend. Nothing below is a governed vendor record.
    </div>
  );
}

export function VendorLiveBadge({ demoMode }: { demoMode: boolean }) {
  if (demoMode) return null;
  return <Badge tone="success">Live backend</Badge>;
}
